import React from 'react';
import { connect } from 'react-redux';
import TurnstileGate from '../components/global/TurnstileGate';
import AttentionGate from '../components/global/AttentionGate';
import Overlay from '../components/global/Overlay';
import Intro from '../containers/intro/intro';
import Orb from './Orb';
import V2Stage, { answeredCount } from './V2Stage';
import V2Answers from './V2Answers';
import './v2.scss';

const noop = () => {};

const Backdrop = () => (
  <div className="v2-backdrop" aria-hidden="true">
    <i className="v2-blob v2-blob--1" />
    <i className="v2-blob v2-blob--2" />
    <i className="v2-blob v2-blob--3" />
  </div>
);

// Shown while the survey loads, before the store knows anything to render.
export const V2Splash = () => (
  <div className="v2">
    <Backdrop />
    <div className="v2-splash">
      <Orb size={96} mood="thinking" />
    </div>
  </div>
);

function Header({ typing, done, answered, total }) {
  const step = Math.min(answered + 1, total);
  return (
    <header className="v2-header">
      <strong>Ellie</strong>
      <span>{done ? 'Klart!' : typing ? 'tänker…' : total ? `Fråga ${step} av ${total}` : ''}</span>
    </header>
  );
}

function V2App({ cookies, survey, seenIntro, thinking, end, answered, awaitingAnswer }) {
  const total = survey.q_count;
  return (
    <div className="v2">
      <Backdrop />
      <div className="v2-shell">
        {seenIntro && <Header typing={thinking === 'robot'} done={!!end} answered={answered} total={total} />}
        <TurnstileGate theme="dark">
          {!seenIntro ? (
            <div className="v2-intro">
              <Orb size={132} />
              <Intro outro={noop} goExtra={noop} fadeOut={noop} videoEnded={noop} />
              {total > 0 && <p className="v2-intro__meta">{total} frågor · tar ungefär en minut</p>}
            </div>
          ) : (
            <AttentionGate>
              <V2Stage cookies={cookies} answers={awaitingAnswer && !end ? <V2Answers /> : null} />
            </AttentionGate>
          )}
        </TurnstileGate>
      </div>
      <Overlay />
    </div>
  );
}

const mapStateToProps = (state) => {
  const thread = state.thread.thread;
  const last = thread[thread.length - 1];
  return {
    survey: state.app.survey,
    seenIntro: state.app.seenIntro,
    thinking: state.app.thinking,
    end: state.app.endQuestion,
    answered: answeredCount(thread),
    // Options show only once Ellie has asked and the respondent has not replied yet.
    awaitingAnswer:
      !!state.app.questions[state.app.currentQuestion] && !!last && !!last.question && state.app.thinking !== 'robot',
  };
};

export default connect(mapStateToProps)(V2App);
